export default "__VITE_ASSET__DrKZ3Xzi__"